import { ContentType, type RequestExtraParams, request } from '@/utils/request'

export interface CustomerContactApiItem {
  contactType?: number | string
  configType?: number | string
  type?: number | string
  title?: string
  desc?: string
  iconUrl?: string
  icon?: string
  displayPhone?: string
  dialPhone?: string
  phone?: string
  buttonDesc?: string
}

export interface CustomerSitePhoneApiItem {
  title?: string
  desc?: string
  iconUrl?: string
  displayPhone?: string
  dialPhone?: string
}

export interface CustomerSitePhoneConfigApiItem {
  siteName?: string
  site?: string
  phoneItemList?: CustomerSitePhoneApiItem[]
  phoneList?: CustomerSitePhoneApiItem[]
}

export interface CustomerContactDetailApiBody {
  site?: string
  list?: CustomerContactApiItem[]
  contactList?: CustomerContactApiItem[]
  contactItemList?: CustomerContactApiItem[]
  items?: CustomerContactApiItem[]
}

export interface SeaTurtleApiCustomerContactDetailPostData {
  status?: number
  message?: string
  body?: CustomerContactDetailApiBody
}

export interface SeaTurtleApiCustomerConfigAllPostData {
  status?: number
  message?: string
  body?: CustomerSitePhoneConfigApiItem[]
}

const baseUrl = '/sea_shell'

/** 当前站点联系方式详情 */
export function seaTurtleApiCustomerContactDetailPost(root: object, params: RequestExtraParams = {}) {
  return request<SeaTurtleApiCustomerContactDetailPostData, any>({
    url: `${baseUrl}/sea_turtle_api/customerContact/detail`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}

/** 所有站点客服电话列表 */
export function seaTurtleApiCustomerConfigAllPost(root: object, params: RequestExtraParams = {}) {
  return request<SeaTurtleApiCustomerConfigAllPostData, any>({
    url: `${baseUrl}/sea_turtle_api/customerConfig/all`,
    method: 'POST',
    data: root,
    contentType: ContentType.Json,
    ...params,
  })
}
